// Display formatting. The engine keeps full precision; rounding happens only here (PRD §3).

const usd0 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const usd2 = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const num1 = new Intl.NumberFormat("en-US", { maximumFractionDigits: 1 });
const num0 = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

/** Annual or large amounts: whole dollars. */
export const money = (n: number) => usd0.format(n);
/** Rates and allocations: cents. */
export const cents = (n: number) => usd2.format(n);
export const perHour = (n: number) => `${usd2.format(n)}/h`;
export const hours = (n: number) => `${num1.format(n)} h`;
export const count = (n: number) => num0.format(n);
export const pct = (fraction: number, digits = 1) => `${(fraction * 100).toFixed(digits).replace(/\.0+$/, "")}%`;

// Dates read YYYY-MM-DD everywhere (Chris, 2026-10-14); months YYYY-MM; times 24-hour.

/** A date as YYYY-MM-DD, or a dash when there is none. */
export function day(iso: string | undefined | null): string {
  return iso ? iso.slice(0, 10) : "—";
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
/** 2026-10-13 → Tue 2026-10-13. */
export const weekdayDay = (iso: string) => `${WEEKDAYS[new Date(`${iso.slice(0, 10)}T12:00:00Z`).getUTCDay()]} ${iso.slice(0, 10)}`;

/** YYYY-MM-DD HH:MM for an instant, in a time zone (the viewer's own when none is given). */
export function stamp(ts: string, timeZone?: string): string {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", { timeZone, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" })
      .formatToParts(new Date(ts))
      .map((p) => [p.type, p.value]),
  );
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
}

/** An ISO timestamp in the viewer's local time: YYYY-MM-DD HH:MM. */
export const when = (ts: string) => stamp(ts);

/** Parses a typed amount ("150,000", "$82.50") to a number, or NaN. */
export const parseAmount = (text: string) => (text.trim() === "" ? NaN : Number(text.replace(/[$,\s]/g, "")));

/** Signed change for previews: +$5.09/h, −$1,200. */
export function delta(n: number, f: (x: number) => string) {
  if (Math.abs(n) < 0.005) return "no change";
  return `${n > 0 ? "+" : "−"}${f(Math.abs(n))}`;
}
